import React from "react";
import ReactMapboxGl, {Layer, Feature} from 'react-mapbox-gl';
import {Legend, LegendElements, MobileLegend} from "../Styles";
import housegt55 from '../../Assets/house55.svg';
import house55 from '../../Assets/houselt55.svg';
import house40 from '../../Assets/house40.svg';
import house30 from '../../Assets/house30.svg';
import house25 from '../../Assets/house25.svg';
import {layoutGenerator} from "react-break";

const screen = layoutGenerator({
    mobile: 0,
    phablet: 550,
    tablet: 768,
    desktop: 992,
});
const OnMobileTablet = screen.isAtMost('phablet');
;
const OnAtLeastTablet = screen.isAtLeast('tablet');


const MARKER_SIZE = 16;
const PRICE_CATEGORY_lt_25 = "lt25"
const PRICE_CATEGORY_lt_30 = "lt30"
const PRICE_CATEGORY_lt_40 = "lt40"
const PRICE_CATEGORY_lt_55 = "lt55"
const PRICE_CATEGORY_gt_55 = "gt55"

const Mapbox = ReactMapboxGl({
    accessToken:
    process.env.REACT_APP_MAPBOX_KEY,
    scrollZoom: true
});

const getPriceCategory = (list) => {

    const price = list.map(i => i.price).reduce((pre, nex) => {
        return (nex.price < pre.price) ? nex : pre;
    });

    if (price <= 25000) {
        return PRICE_CATEGORY_lt_25
    } else if (price <= 30000) {
        return PRICE_CATEGORY_lt_30
    } else if (price <= 40000) {
        return PRICE_CATEGORY_lt_40
    } else if (price <= 55000) {
        return PRICE_CATEGORY_lt_55
    } else {
        return PRICE_CATEGORY_gt_55
    }
};

const getImageFromPriceCategory = (priceCategory) => {
    if (priceCategory === PRICE_CATEGORY_lt_25) {
        return house25
    } else if (priceCategory === PRICE_CATEGORY_lt_30) {
        return house30
    } else if (priceCategory === PRICE_CATEGORY_lt_40) {
        return house40
    } else if (priceCategory === PRICE_CATEGORY_lt_55) {
        return house55
    } else {
        return housegt55
    }
};

const getLocationKey = (location) => {
    return location.lat + ',' + location.lng;
};

const groupByLocation = (entries) => {
    const placesMap = new Map();
    entries.forEach((e) => {
        const key = getLocationKey(e.location);

        if (!placesMap.has(key)) {
            placesMap.set(key, [])
        }

        placesMap.get(key).push(e)
    });
    return placesMap;
};

const getCoordinatesByPriceCategoryMap = () => {
    const coordinatesByPriceCategory = new Map();
    coordinatesByPriceCategory.set(PRICE_CATEGORY_lt_25, []);
    coordinatesByPriceCategory.set(PRICE_CATEGORY_lt_30, []);
    coordinatesByPriceCategory.set(PRICE_CATEGORY_lt_40, []);
    coordinatesByPriceCategory.set(PRICE_CATEGORY_lt_55, []);
    coordinatesByPriceCategory.set(PRICE_CATEGORY_gt_55, []);
    return coordinatesByPriceCategory;
};

const equalCoordinates = (o1, o2) => {
    return o1.lat === o2.lat && o1.lng === o2.lng;
};

const EntriesMap = ({refference, onPlacesClicked, entries, size}) => {
        const placesByCoordinates = groupByLocation(entries);
        const placesByPriceCategory = getCoordinatesByPriceCategoryMap();

        const lastClickedCoordinates = {lat: 0.0, lng: 0.0};
        const getLayer = (priceCategory, onClick) => {
            const img = new Image(MARKER_SIZE, MARKER_SIZE);
            img.src = getImageFromPriceCategory(priceCategory);
            const images = [priceCategory, img];

            return <Layer id={priceCategory} type="symbol"
                          layout={{'icon-image': priceCategory, 'icon-allow-overlap': true,}} images={images}>
                {placesByPriceCategory.get(priceCategory).map(item =>
                    <Feature properties={{itemLocationKey: getLocationKey(item.location)}}
                             coordinates={[item.location.lng, item.location.lat]} onClick={(e) => {
                        if (!equalCoordinates(lastClickedCoordinates, e.lngLat)) {
                            lastClickedCoordinates.lat = e.lngLat.lat;
                            lastClickedCoordinates.lng = e.lngLat.lng;
                            onClick(placesByCoordinates.get(e.feature.properties.itemLocationKey))
                        }
                    }}/>)}
            </Layer>
        };

        placesByCoordinates.forEach((list, coordinates) => {
            placesByPriceCategory.get(getPriceCategory(list)).push(list[0]);
        });

        const layers = [];
        placesByPriceCategory.forEach((items, priceCategory) => {
            layers.push(getLayer(priceCategory, onPlacesClicked));
        });

        return (
            <div style={{height: '500px'}} ref={refference}>

                <div>
                    <Mapbox
                        onClick={(map, e) => {
                            if (!equalCoordinates(e.lngLat, lastClickedCoordinates)) {
                                onPlacesClicked([])
                            }
                        }}
                        style="mapbox://styles/mapbox/streets-v9?optimize=true"
                        containerStyle={{
                            height: '500px',
                            borderRadius: '20px',
                            width: size,
                        }}
                        zoom={[13]}
                        center={[19.8158222, 41.3228143]}
                        maxBounds={[[19.739037, 41.287521], [19.912434, 41.363461]]}
                    >

                        {layers}
                        <OnAtLeastTablet>
                            <Legend>
                                <LegendElements style={{marginTop: '8px'}}><img src={house55}/>  &lt;55.000
                                    Lek</LegendElements>
                                <LegendElements><img src={housegt55}/> &gt;55.000 Lek</LegendElements>
                                <LegendElements><img src={house40}/> &lt;40.000 Lek</LegendElements>
                                <LegendElements><img src={house30}/> &lt;30.000 Lek</LegendElements>
                                <LegendElements><img src={house25}/> &lt;25.000 Lek</LegendElements>
                            </Legend>
                        </OnAtLeastTablet>

                        <OnMobileTablet>
                            <MobileLegend>
                                <LegendElements style={{marginTop: '8px'}}><img src={house55}/>  &lt;55.000
                                    Lek</LegendElements>
                                <LegendElements><img src={housegt55}/> &gt;55.000 Lek</LegendElements>
                                <LegendElements><img src={house40}/> &lt;40.000 Lek</LegendElements>
                                <LegendElements><img src={house30}/> &lt;30.000 Lek</LegendElements>
                                <LegendElements><img src={house25}/> &lt;25.000 Lek</LegendElements>
                            </MobileLegend>
                        </OnMobileTablet>
                    </Mapbox>
                </div>
            </div>

        );
    }
;

export default EntriesMap;
